require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./betreuungseinrichtungen-guessing-tobaj.json") })
        }
      }, "path---betreuungseinrichtungen-guessing-tobaj");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---betreuungseinrichtungen-guessing-tobaj!./.cache/json/betreuungseinrichtungen-guessing-tobaj.json
// module id = 906
// module chunks = 231608221292675